/**
 * PHYSICAL-RISK-EVALUATION-STEP
 * Etape Evaluation : le niveau de prevention se choisit dans l'entonnoir, a gauche. Le detail des
 * calculs, a droite, montre le risque qui en decoule.
 */
import PhysicalRiskCalculationDetails from "@/entities/physical-risk/ui/wizard/PhysicalRiskCalculationDetails"
import PhysicalRiskPreventionFunnel from "@/entities/physical-risk/ui/PhysicalRiskPreventionFunnel"

interface Props {
  onEditFrequency: () => void
  onEditSeverity: () => void
}

export default function PhysicalRiskEvaluationStep({ onEditFrequency, onEditSeverity }: Props) {
  return (
    <div className="mt-20 flex flex-wrap items-start gap-20">
      <div className="min-w-[280px] flex-1">
        <PhysicalRiskPreventionFunnel />
      </div>
      <PhysicalRiskCalculationDetails
        step="prevention"
        onEditFrequency={onEditFrequency}
        onEditSeverity={onEditSeverity}
      />
    </div>
  )
}
